export const THEME = {
  bg: '#FAFAF9',
  surface: '#FFFFFF',
  border: '#E7E5E4',
  hover: '#F0EFED',
  active: '#E8E6E3',
  text: '#1C1917',
  muted: '#000000',
  accent: '#00363D',
  success: '#15803D',
  successBg: '#F0FDF4',
}

export const SERIF = 'Georgia, "Times New Roman", serif'
